<div class="w-100 h-100">
  <app-spot-map #spotMap id="spotMap" [isClickable]="true"></app-spot-map>
</div>
